import { render, staticRenderFns } from "./ColumnModal.vue?vue&type=template&id=5b1af28c&scoped=true"
import script from "./ColumnModal.vue?vue&type=script&lang=js"
export * from "./ColumnModal.vue?vue&type=script&lang=js"
import style0 from "./ColumnModal.vue?vue&type=style&index=0&id=5b1af28c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1af28c",
  null
  
)

export default component.exports